import styled from 'react-emotion'
import { border, space4 } from '../style'
import Modal from 'common/Modal/index'

export const Hr = styled('hr')({
  border: 'none',
  borderBottom: border,
  margin: 0,
  marginBottom: space4,
  width: '100%',
  [`${Modal} &`]: {
    marginLeft: -space4,
    marginRight: -space4,
    width: 'auto'
  }
})
export default Hr
